import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Text, Box, Flex } from "@chakra-ui/react";
import NavigationBar from "src/components/NavigationBar";
import ListButton from "src/components/ListButton";
import openExternal from "src/utils/openExternal";
import { getSubscription } from "src/modules/auth/duck/selectors";

import { ReactComponent as UpdateIcon } from "./update.svg";
import { ReactComponent as CloseIcon } from "./close.svg";

export default function ManageSubscription({ onBack, onClose }) {
  const subscription = useSelector(getSubscription);
  const { t } = useTranslation();
  return (
    <>
      <NavigationBar
        headingKey="purchase.manageSubscription"
        onBack={onBack}
        onClose={onClose}
      />
      <Box px="24px" mt="32px">
        <Flex mb="24px">
          <Box key="purchase.manageSubscription.update" width="50%" pr="24px">
            <ListButton
              icon={UpdateIcon}
              labelKey="purchase.manageSubscription.update"
              onClick={() => openExternal({ url: subscription?.updateUrl })}
            />
          </Box>
          <ListButton
            icon={CloseIcon}
            labelKey="purchase.manageSubscription.cancel"
            onClick={() => openExternal({ url: subscription?.cancelUrl })}
            width="50%"
          />
        </Flex>
        <Text
          mt="24px"
          fontSize="10px"
          lineHeight="1.2"
          letterSpacing="0.1px"
          color="mediumEmphasis"
        >
          {t("purchase.manageSubscription.text")}
        </Text>
      </Box>
    </>
  );
}
